/* Skeleton grid that mimics <PaymentPlanCard> layout
   -------------------------------------------------- */
import classNames from 'classnames'

const SkeletonCard = ({ isMobile }) => (
  <div
    className={classNames(
      'animate-pulse rounded-sm border-xs border-[#cbcbcb] bg-white px-16',
      isMobile ? 'pt-24 pb-16' : 'py-24'
    )}
  >
    {/* title & price */}
    <div className="mb-6 h-6 w-2/3 rounded bg-[#e5e5e5]" />
    <div className="mb-4 h-8 w-1/3 rounded bg-[#e5e5e5]" />

    <div className="h-[1px] w-full bg-[#e5e5e5]" />

    {/* desk = list • mobile = meta columns */}
    {isMobile ? (
      <>
        <div className="my-6 flex justify-between">
          {[1, 2, 3].map(k => (
            <div key={k} className="h-5 w-16 rounded bg-[#e5e5e5]" />
          ))}
        </div>
        <div className="h-20 w-full rounded bg-[#f5f5f5]" />
      </>
    ) : (
      <div className="mt-6 space-y-3">
        {[...Array(4)].map((_, i) => (
          <div key={i} className="h-4 w-1/2 rounded bg-[#e5e5e5]" />
        ))}
      </div>
    )}
  </div>
)

export const PaymentPlansSkeleton = ({ windowSize }) => {
  const isMobile = windowSize <= 980
  const COLS      = windowSize > 980 ? 3 : 1          // keep grid break-points
  const cards     = Array(COLS).fill(0)

  return (
    <div className={classNames('grid gap-4', COLS === 3 ? 'grid-cols-3' : 'grid-cols-1')}>
      {cards.map((_, idx) => (
        <SkeletonCard key={idx} isMobile={isMobile} />
      ))}
    </div>
  )
}
